const prefetches = new Set();

function init() {
  if (!document.createElement("link").relList.supports("prefetch")) {
    return;
  }

  const links = document.querySelectorAll(
    `a[href^='/'],a[href*='${location.origin}']`,
  );

  links.forEach((link) => {
    if (link.search || link.pathname === location.pathname) {
      return;
    }

    link.addEventListener("pointerenter", pointerenter, {
      passive: true,
    });
  });
}

function pointerenter({ currentTarget: link }) {
  const timeout = setTimeout(() => preload(link), 65);
  link.addEventListener("pointerleave", () => pointerleave(timeout), {
    passive: true,
  });
}

function pointerleave(timeout) {
  clearTimeout(timeout);
}

function preload(link) {
  link.removeEventListener("pointerenter", pointerenter);
  link.removeEventListener("pointerleave", pointerleave);

  if (prefetches.has(link.href)) {
    return;
  }

  const prefetcher = document.createElement("link");
  prefetcher.rel = "prefetch";
  prefetcher.href = link.href;
  document.head.append(prefetcher);

  prefetches.add(link.href);
}

init();
